/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import {
  setAllClaimHistory,
  setClaimTicketLoader,
} from '../../../../infra/aggregates/myProfile/claimAggregates/claimHistorySlice';
import { claimService } from '../../../../api/services/claimService';
import { setAllAirTicketHistory } from '../../../../infra/aggregates/myProfile/claimAggregates/airTicketHistorySlice';

interface PropsValues {
  setEmpClaimHistory: (data: any) => void;
  setEmpAirTicketHistory: (data: any) => void;

  yearFilter: number;
}

function DTOClaimHistory({
  setEmpClaimHistory,
  setEmpAirTicketHistory,
  yearFilter,
}: PropsValues) {
  const selector = useAppSelector((state) => state.authSlice);

  const claimHistory_stored = useAppSelector(
    (state) => state.claimHistorySlice.claimHistory,
  );
  const airTicketHistory_stored = useAppSelector(
    (state) => state.airTicketHistorySlice.airTicketHistory,
  );
  const dispatch = useAppDispatch();
  async function getEmpLeaveHistory(empId: number, companyId: number) {
    dispatch(setClaimTicketLoader(true));
    const response = await claimService.getAllClaimHistory(empId, companyId);
    if (response) {
      const air_tickets_history = response?.data?.air_tickets;
      const claims_history = response?.data?.claims;

      dispatch(setAllAirTicketHistory(air_tickets_history));
      dispatch(setAllClaimHistory(claims_history));
      setEmpClaimHistory(claims_history);
      setEmpAirTicketHistory(air_tickets_history);
      dispatch(setClaimTicketLoader(false));
    } else {
      dispatch(setClaimTicketLoader(false));

      return;
    }
  }

  async function getEmpLeaveHistoryWithYear(
    empId: number,
    companyID: number,
    year: number,
  ) {
    dispatch(setClaimTicketLoader(true));
    const response = await claimService.getAllClaimHistoryWithYear(
      empId,
      companyID,
      year,
    );

    if (response?.response === 'success') {
      const air_tickets_history = response?.data?.air_tickets;
      const claims_history = response?.data?.claims;

      dispatch(setAllAirTicketHistory(air_tickets_history));
      dispatch(setAllClaimHistory(claims_history));
      setEmpClaimHistory(claims_history);
      setEmpAirTicketHistory(air_tickets_history);
      dispatch(setClaimTicketLoader(false));
    } else {
      dispatch(setClaimTicketLoader(false));
      return;
    }
  }
  useEffect(() => {
    if (selector.emp_id && selector.company_id)
      getEmpLeaveHistory(selector.emp_id, selector.company_id);
  }, []);

  useEffect(() => {
    if (yearFilter != 0) {
      getEmpLeaveHistoryWithYear(
        selector.emp_id,
        selector.company_id,
        yearFilter,
      );
    }
  }, [yearFilter]);

  useEffect(() => {
    setEmpClaimHistory(claimHistory_stored);
    setEmpAirTicketHistory(airTicketHistory_stored);
  }, [claimHistory_stored, airTicketHistory_stored]);

  return <></>;
}
export default DTOClaimHistory;
